<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <main class='keepalive wrapper'>
        <Transition @enter="started" @after-enter="ended" appear>
          <component :key='route.path.split("/").slice(0, 3).join("/")' class='view' :is="Component" />
        </Transition>
      </main>
    </keep-alive>
  </router-view>
</template>

<script setup>
  import { useRoute } from 'vue-router';
  import { ref } from 'vue';
  const emit = defineEmits(['transitionStarted', 'transitionEnded'])
  const route = useRoute()
  const transitionActive = ref(false)
  const started = function() {
    emit('transitionStarted')
    transitionActive.value = true;
  }
  const ended = function() {
    emit('transitionEnded')
    transitionActive.value = false;
  }
</script>

<style scoped>
  main.wrapper {
    position: relative;
    z-index: 1;
    --time: 100ms;
    --transform: translateY(0rem);
    --bezier: cubic-bezier(0.56,0.01,0.4,1);
  }

  main.wrapper:deep(main.view) {
    z-index: 1;
    position: relative;
    will-change: opacity;
    transform: translate3d(0,0,0);
  }

  main.wrapper:deep(main.view).v-enter-active {
    transition: all var(--time) var(--bezier) var(--time);
    position: absolute;
    top: 0;
  }

  main.wrapper:deep(main.view).v-leave-active {
    transition: all var(--time) var(--bezier) 0ms;
    position: absolute;
    top: 0;
    /* transform-origin: 0% 50%; */
  }

  main.wrapper:deep(main.view).view.v-enter-active {
    opacity: 0.01;
    transform: var(--transform);
    /* transform-origin: 100% 50%; */
  }

  main.wrapper:deep(main.view).view.v-enter-to {
    opacity: 1;
    transform: none;
  }

  main.wrapper:deep(main.view).view.v-leave {
    opacity: 1;
    transform: none;
  }

  main.wrapper:deep(main.view).view.v-leave-to {
    opacity: 0.01;
    transform: var(--transform);
  }

</style>
